import { Container, Grid } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'
import { GlobalLinksCtaFragment } from '../../../fragments/__generated__/linksCtaFallback'
import { isNotNull, nonNull } from '../../../utils/nonNull'
import { PageProps } from '../index'
import {
  SlantedBottomGreyBackground,
  StyledDisclaimerWrapper,
  StyledFAQsWrapper,
  StyledInfoLinkWrapper,
  StyledLinkCTAWrapper,
} from '../styledProductListing'
import { FaqFragment } from './__generated__/faqs'
import { Disclaimer } from './disclaimer'
import { ProductFAQs } from './faqs'
import { InfoLinks } from './infoLinks'
import { LinksCTA } from './linksCta'

export const BelowTheFold: React.FC<PropsWithChildren<PageProps>> = (data) => {
  if (!data.entry || data.entry.__typename !== 'products_pages_product_listing_Entry') {
    return null
  }

  const { linksCtaFallback, entry } = data
  const { linksCta, informationLinks, productCustomFaqs, disclaimer_entry_field, generalDisclaimers } = entry

  const customFaqs = isNotNull(productCustomFaqs) ? productCustomFaqs[0] as FaqFragment : null

  const disclaimer_entry = disclaimer_entry_field

  return (
    <>
      <StyledFAQsWrapper>
        <ProductFAQs data={nonNull([customFaqs])}/>
      </StyledFAQsWrapper>
      <SlantedBottomGreyBackground>
        <Container component="section">
          {informationLinks && (
            <StyledInfoLinkWrapper container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              wrap="nowrap"
            >
              <InfoLinks data={nonNull(informationLinks)}/>
            </StyledInfoLinkWrapper>
          )}
          {linksCta && linksCtaFallback && (
            <StyledLinkCTAWrapper container
              direction="column"
              justifyContent="center"
              alignItems="center"
              wrap="nowrap"
            >
              <LinksCTA data={nonNull(linksCta)} fallback={linksCtaFallback as GlobalLinksCtaFragment}/>
            </StyledLinkCTAWrapper>
          )}
        </Container>
      </SlantedBottomGreyBackground>
      {disclaimer_entry && (
        <StyledDisclaimerWrapper>
          <Container component="section">
            <Grid container item xs={12} sm={12}
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              wrap="nowrap"
            >
              <Disclaimer data={nonNull(disclaimer_entry)} general={nonNull(generalDisclaimers ?? [])}/>
            </Grid>
          </Container>
        </StyledDisclaimerWrapper>
      )}
    </>
  )
}